const handlePublicRouteChange = (hash: string) => {
  // Need to force reload because campaign route is in different Routes pack
  window.location.href = hash
  window.location.reload()
}

export default handlePublicRouteChange
